import { AxiosResponse } from 'axios';
import { createContext } from 'react';
import LoginCustomer from '../models/data/LoginCustomer';
import LoginRequest from '../models/requests/LoginRequest';

export type LoginAsyncFunction = (
  req?: LoginRequest,
) => Promise<AxiosResponse<LoginCustomer>>;

export type LogoutAsyncFunction = () => Promise<AxiosResponse<void>>;

export type AuthenticatedContextType = {
  isAuthenticated: boolean;
  loginCustomer?: LoginCustomer;
  login: LoginAsyncFunction;
  logout: LogoutAsyncFunction;
};

const AuthenticatedContext = createContext<AuthenticatedContextType>({
  isAuthenticated: false,
  login: async () => Promise.reject(new Error('Unsupported Operation')),
  logout: async () => Promise.reject(new Error('Unsupported Operation')),
});

export const AuthenticatedContextProvider = AuthenticatedContext.Provider;

export const AuthenticatedContextConsumer = AuthenticatedContext.Consumer;

export default AuthenticatedContext;
